const ITEMS = [
    "Reformer Studio",
    "Reformer Flow",
    "Gentle Pilates",
    "Posturale Lago",
    "Private 1:1",
    "Cernobbio · Lago di Como",
];

const Row = ({ hidden }) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden}>
        {ITEMS.map((item) => (
            <span key={item + (hidden ? "-b" : "-a")} className="flex items-center">
                <span className="whitespace-nowrap px-10 text-xs font-medium uppercase tracking-[0.35em] text-white/80">
                    {item}
                </span>
                <span className="h-1 w-1 bg-ochre" aria-hidden="true" />
            </span>
        ))}
    </div>
);

export default function MarqueeTicker() {
    return (
        <div
            data-testid="marquee-ticker"
            className="overflow-hidden border-b border-hairline bg-ink py-4"
        >
            <div className="marquee-track flex w-max">
                <Row hidden={false} />
                <Row hidden={true} />
            </div>
        </div>
    );
}
